module.exports = __webpack_public_path__ + "static/media/cross-gray.34cbb8a3.svg";